import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { clinicsAPI, authAPI } from '../services/api'
import './DashboardPage.css'

function DashboardPage() {
  const [clinics, setClinics] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const navigate = useNavigate()
  
  useEffect(() => {
    // Check authentication
    authAPI.checkAuth().then(isAuth => {
      if (!isAuth) {
        navigate('/login')
        return
      }
      loadClinics()
    }).catch(err => {
      console.error('Auth check error:', err)
      navigate('/login')
    })
  }, [navigate])
  
  const loadClinics = async () => {
    try {
      setLoading(true)
      setError('')
      const data = await clinicsAPI.listClinics()
      setClinics(data.clinics || [])
    } catch (err) {
      const errorMsg = err.response?.data?.error || err.message || 'Błąd ładowania klinik.'
      setError(errorMsg)
      console.error('Load clinics error:', err)
    } finally {
      setLoading(false)
    }
  }
  
  const handleDelete = async (id, name) => {
    if (!window.confirm(`Czy na pewno chcesz usunąć klinikę "${name}"?`)) {
      return
    }
    
    try {
      await clinicsAPI.deleteClinic(id)
      loadClinics() // Reload list
    } catch (err) {
      const errorMsg = err.response?.data?.error || err.message || 'Błąd usuwania kliniki.'
      alert(errorMsg)
      console.error('Delete clinic error:', err)
    }
  }
  
  const handleLogout = async () => {
    await authAPI.logout()
    navigate('/login')
  }
  
  return (
    <div className="dashboard-page">
      <header className="dashboard-header">
        <div className="header-content">
          <div className="logo">WELLYSA</div>
          <h1>Panel Administracyjny</h1>
        </div>
        <button onClick={handleLogout} className="btn-secondary">
          Wyloguj
        </button>
      </header>
      
      <main className="dashboard-main">
        <div className="dashboard-actions">
          <button 
            onClick={() => navigate('/clinics/new')} 
            className="btn-primary"
          >
            + Dodaj Klinikę
          </button>
        </div>
        
        {error && <div className="error-message">{error}</div>}
        
        {loading ? (
          <div className="loading">Ładowanie...</div>
        ) : (
          <div className="clinics-table-container">
            <table className="clinics-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Nazwa</th>
                  <th>Kod</th>
                  <th>Email</th>
                  <th>Telefon</th>
                  <th>Status</th>
                  <th>Akcje</th>
                </tr>
              </thead>
              <tbody>
                {clinics.length === 0 ? (
                  <tr>
                    <td colSpan="7" className="empty-state">
                      Brak klinik. Dodaj pierwszą klinikę.
                    </td>
                  </tr>
                ) : (
                  clinics.map(clinic => (
                    <tr key={clinic.id}>
                      <td>{clinic.id}</td>
                      <td>{clinic.name}</td>
                      <td><code>{clinic.code}</code></td>
                      <td>{clinic.contact_email || '-'}</td>
                      <td>{clinic.contact_phone || '-'}</td>
                      <td>
                        <span className={`status-badge ${clinic.is_active === 1 ? 'active' : 'inactive'}`}>
                          {clinic.is_active === 1 ? 'Aktywna' : 'Nieaktywna'}
                        </span>
                      </td>
                      <td>
                        <div className="actions">
                          <button
                            onClick={() => navigate(`/clinics/${clinic.id}/edit`)}
                            className="btn-link"
                          >
                            Edytuj
                          </button>
                          <button
                            onClick={() => handleDelete(clinic.id, clinic.name)}
                            className="btn-link btn-danger"
                          >
                            Usuń
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}
      </main>
    </div>
  )
}

export default DashboardPage
